import React, { useState, useEffect, useContext } from "react";
import { db } from "@healthdesk/shared-services";
import { AuthContext } from "./Auth";

export const LocationContext = React.createContext(null);

function mapLocationDoc(doc) {
  return { ...doc.data(), id: doc.id };
}

export const LocationProvider = ({ children }) => {
  const auth = useContext(AuthContext);
  if (auth === undefined) {
    throw new Error("LocationProvider must be used within an AuthProvider");
  }
  const { user, userData } = auth;

  const [location, setLocation] = useState(null);
  const [locationLoaded, setLocationLoaded] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setLocation(null);
      setLocationLoaded(false);
      return undefined;
    }

    let fallbackUnsub = null;

    const usersUnsub = db
      .collection("locations")
      .where("users", "array-contains", user.uid)
      .onSnapshot((querySnapshot) => {
        if (!querySnapshot.empty) {
          if (fallbackUnsub) {
            fallbackUnsub();
            fallbackUnsub = null;
          }
          querySnapshot.forEach((doc) => {
            setLocation(mapLocationDoc(doc));
          });
          setLocationLoaded(true);
          return;
        }

        const assignedLocationId =
          typeof userData?.location === "string" ? userData.location.trim() : "";
        if (assignedLocationId) {
          if (!fallbackUnsub) {
            fallbackUnsub = db
              .collection("locations")
              .doc(assignedLocationId)
              .onSnapshot((docSnap) => {
                if (docSnap.exists) {
                  setLocation(mapLocationDoc(docSnap));
                } else {
                  setLocation(null);
                }
                setLocationLoaded(true);
              });
          }
          return;
        }

        setLocation(null);
        setLocationLoaded(true);
      });

    return () => {
      usersUnsub();
      if (fallbackUnsub) fallbackUnsub();
    };
  }, [user?.uid, userData?.location]);

  return (
    <LocationContext.Provider
      value={{
        location,
        locationLoaded,
      }}
    >
      {children}
    </LocationContext.Provider>
  );
};
